import actionTypes from '../constants/action-types';

const addCustomColor = (color) => ({
  type: actionTypes.ADD_CUSTOM_COLOR,
  payload: {
    color,
  },
});

export default addCustomColor;
